import React from 'react';
import { QuestionRenderer } from './questions/QuestionRenderer';
import { ErrorMessage } from './ErrorMessage';
import { NavigationButtons } from './NavigationButtons';
import parse from 'html-react-parser';

export function QuestionCard({ question, value, error, onChange, navigationProps, allAnswers }) {
  return (
    <div className="bg-white rounded-2xl shadow-xl">
      {/* Sticky Question Header */}
      <div className="sticky top-0 z-30 bg-white rounded-t-2xl border-b border-gray-200 p-4 sm:p-6 shadow-sm backdrop-blur-sm bg-white/95">
        <h2 className="text-lg sm:text-2xl font-bold text-gray-800 mb-2">{question.question}</h2>
        {question.subtitle && (
          <p className="text-gray-500 text-xs sm:text-sm">{parse(question.subtitle)}</p>
        )}
      </div>

      {/* Question Content */}
      <div className="p-4 sm:p-8 pt-6 sm:pt-8">
        <QuestionRenderer
          question={question}
          value={value}
          onChange={onChange}
          allAnswers={allAnswers}
        />

        <ErrorMessage message={error} />
        <NavigationButtons {...navigationProps} />
      </div>
    </div>
  );
}
